import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { imagesReducer } from "./reducers/imagesReduser";
import { userDataReduser } from "./reducers/userDataReducer";
import { userBalanceReduser } from "./reducers/balanceReduser";
import { ordersReduser } from "./reducers/ordersReduser";

const rootReducer = combineReducers({
  images: imagesReducer,
  userData: userDataReduser,
  balance: userBalanceReduser,
  orders: ordersReduser
});

export const store = configureStore({
  reducer: rootReducer
});